/** @format */

import React, { useState } from "react";
import { Row, Col } from "antd";
import Icon from "@ant-design/icons";
import certificationIcon from "../../public/filestore/certificationIcon";

function Certifications(props) {
  let { mobile = false, certificates = [] } = props;
  const [index,setIndex]= useState(3)
  const [more, setMore] = useState(false)
  const viewMore = () => {
    setIndex(certificates.length - 1)
    setMore(true)
  }
  const viewLess = (e) =>{
   setMore(false)
    setIndex(3)

  }
  return (<>
    <Row className={certificates.length<4 ? "qa-mar-btm-2":''}>
      {certificates.map((certificate, i) => {
        return (
         i <= index &&
          <Col
            className={mobile ? "qa-mar-btm-2" : "qa-pad-24 qa-mar-btm-2"}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
            key={i}
          >
            <div className="qa-bg-light-theme">
              <div className="qa-disp-table-cell cert-left-blk">
                <Icon
                  component={certificationIcon}
                  className="certificate-icon"
                />
              </div>
              <div className="qa-disp-table-cell qa-pad-2 cert-right-blk">
                <div className="qa-fw-b qa-text-ellipsis qa-tc-white">
                  {certificate.title}
                </div>
                <div className="qa-text-5line qa-fs-14 qa-min-height">
                  {certificate.desc}
                </div>
              </div>
            </div>
          </Col>
        );
      })}
       
    </Row>
  {  certificates.length > 4 && <div className={mobile ? "qa-mar-btm-2 cert-view-more" : "qa-mar-btm-3 cert-view-more"}>
 {  more  ? <div onClick={viewLess}>View less</div> : <div onClick={viewMore}> View more</div>
 }
     </div>}
   </>
  );
}

export default Certifications;
